export default __webpack_public_path__ + "static/10-mouth-watering-destinations-for-unashamed-foodies-vietnam-0feeab7b605e5fb716cdfe68354e3ea0.jpg";